import * as THREE from "three";
import { MeshBasicMaterial, Texture, TextureLoader } from "three";

// importing types
import { IConfig } from "../models/config.model";
import { setTextures } from "../store/slices/config.slice";
import { AppDispatch } from "../store/store";

// importing helper
import numberToSide from "./Side.helper";

const loader: TextureLoader = new THREE.TextureLoader();

export async function getImages(config: IConfig, dispatch: AppDispatch) {
  // Loop over all of the images
  for (let i = 0; i < config.scenes.length; i++) {
    const textures: MeshBasicMaterial[] = [];

    // console.log("config", config.scenes[i]);

    // Get each side of the cube to create the cube map
    for (let k = 0; k < 6; k++) {
      // Call texture loader
      await loadTexture(
        `${process.env.PUBLIC_URL}/media/${
          config.scenes[i].image
        }/${numberToSide(k)}.jpg`
      ).then((texture) => {
        // When promise is resolved add loaded texture to array
        texture.encoding = THREE.sRGBEncoding;
        textures.push(
          new THREE.MeshBasicMaterial({
            map: texture,
          })
        );
      });
    }

    // console.log("texture: ", config.scenes[i].id, textures);

    // Once cube map has been created save to the store
    dispatch(setTextures({ id: config.scenes[i].id, texture: textures }));
  }
}

function loadTexture(url: string): Promise<Texture> {
  return new Promise((resolve) => {
    loader.load(url, resolve);
  });
}
